import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { CompanyService } from 'app/services/models/company.service';
import { PersonService } from 'app/services/models/person.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-person',
  templateUrl: './create-person.component.html',
  styleUrls: ['./create-person.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreatePersonComponent implements OnInit {
  @Input() data: { id: number; companyId: number; };
  personForm: FormGroup;
  companies: any;
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private personService: PersonService,
    private companyService: CompanyService,
    public authService:AuthService
  ) { }

  async ngOnInit() {
    console.log(this.data);
    this.personForm = this.fb.group({
      name: [null, Validators.required],
      lastName: [null, Validators.required],
      mission: [null, Validators.required],
      phoneNumber: [null],
      mail: [null],
      address: [null],
      companyId: [null, Validators.required]
    });
    //await this.getAllCompany();
    if (this.data.id) {
      await this.getById(this.data.id);
    }
    if (this.data.companyId) {
      this.personForm.patchValue({
        companyId: this.data.companyId
      });
    }
  }

  async getAllCompany() {
    const data = await this.companyService.getAllDetailCompany();
    this.companies = data;
    console.log(this.companies)
  }

  async getById(id) {
    const data = await this.personService.getByIdPerson(id);
    if (data) {
      this.personForm.patchValue({
        name: data.name,
        lastName: data.lastName,
        mission: data.mission,
        phoneNumber: data.phoneNumber,
        mail: data.mail,
        address: data.address,
        companyId: data.companyId
      });
    }
  }

  async save() {
    if (this.personForm.valid) {
      if (this.data.id) {
        const data = await this.personService.updatePerson(
          this.data.id,
          this.personForm.value.name,
          this.personForm.value.lastName,
          this.personForm.value.mission,
          this.personForm.value.mail,
          this.personForm.value.phoneNumber,
          this.personForm.value.address,
          this.personForm.value.companyId
        );
        if (data.status == true) {
          this.companyService.sendEvent(true);
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        const data = await this.personService.createPerson(
          this.personForm.value.name,
          this.personForm.value.lastName,
          this.personForm.value.mission,
          this.personForm.value.mail,
          this.personForm.value.phoneNumber,
          this.personForm.value.address,
          this.personForm.value.companyId
        );
        if (data.status == true) {
          if ((this.data.companyId && !this.data.id) || (this.data.companyId && this.data.id)) {
            this.personService.sendEvent(true);
            this.companyService.sendEvent(true);
          }
          else{
            this.personService.sendEvent(true);
          }
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
      }
    }
    this.closeModal();
  }

  closeModal() {
    this.activeModal.close(false);
  }

}
